'use client';

import { getStockXUrl, isStockXAffiliateActive } from '@/lib/config/affiliate';
import { useState } from 'react';

interface DebugAffiliateLinksProps {
  sneakerName: string;
  brand?: string;
  slug?: string;
}

/**
 * Composant de debug pour vérifier l'URL StockX générée.
 * À utiliser uniquement en développement : ajoutez ?debug=true dans l'URL pour l'afficher.
 */
export function DebugAffiliateLinks({ sneakerName, brand, slug }: DebugAffiliateLinksProps) {
  const [dismissed, setDismissed] = useState(false);

  const enabled =
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('debug') === 'true';
  if (!enabled || dismissed) return null;

  const url = getStockXUrl({ slug, name: sneakerName, brand });
  const active = isStockXAffiliateActive();

  return (
    <div className="rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-xs text-yellow-900">
      <div className="mb-2 flex items-center justify-between">
        <h4 className="font-bold">DEBUG - URL StockX</h4>
        <button onClick={() => setDismissed(true)} className="font-bold" aria-label="Fermer">
          ✕
        </button>
      </div>
      <code className="block overflow-x-auto rounded border border-yellow-200 bg-white p-2 text-[10px]">{url}</code>
      <ul className="mt-2 space-y-0.5">
        <li>Fiche exacte (slug) : {slug ? 'oui' : 'non, recherche de secours'}</li>
        <li>Affiliation Impact active : {active ? 'oui' : 'non (lien direct, sans commission)'}</li>
        <li>Lien de suivi présent : {url.includes('/c/') ? 'oui' : 'non'}</li>
      </ul>
    </div>
  );
}
